export default __webpack_public_path__ + "static/media/SubQuery.3c1c9a8f.png";